import { render, staticRenderFns } from "./PopupWidget.vue?vue&type=template&id=e4ed6f02&scoped=true&"
import script from "./PopupWidget.vue?vue&type=script&lang=js&"
export * from "./PopupWidget.vue?vue&type=script&lang=js&"
import style0 from "./PopupWidget.vue?vue&type=style&index=0&id=e4ed6f02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ed6f02",
  null
  
)

export default component.exports